import { ALERT_ACTION_TYPES } from '../../_constants';

const INITIAL_STATE = {
    message: '',
    duration: 0,
    severity: '',
    isOpen: false
}

const alertReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ALERT_ACTION_TYPES.TRIGGER:
            return {
                message: action.data.message,
                duration: action.data.duration,
                severity: action.data.severity,
                isOpen: action.data.isOpen,
            };
        case ALERT_ACTION_TYPES.CLEAR:
            return {
                ...state,
                isOpen: false
            };
        default:
            return state
    }
}

export default alertReducer
